import { css } from '@emotion/css';
import { Color, Font, FontWeight, Spacing } from 'src/styles';

export const sectionTitle = css`
  && {
    ${Spacing.mt16}
    ${Spacing.mb16}
  }
  ${Font.sm}
  color: ${Color.Gray6};
`;

export const policyText = css`
  ${Font.sm}
  color: ${Color.Gray6};
  ${Spacing.mb16}
`;

export const nickname = css`
  ${Font.sm}
  color: ${Color.Gray6};
`;

export const senderReceiverTopLabel = css`
  ${FontWeight.semibold}
  text-transform: uppercase;
  color: ${Color.Gray6};
`;

export const bankLogo = css`
  width: 1.5rem;
  height: 1.5rem;
`;

export const tableContainer = css`
  width: 100%;
`;

export const amountValue = ({ isNegative }: { isNegative: boolean }) => css`
  ${FontWeight.bold}
  ${Font.lg}
  color: ${isNegative ? Color.Red8 : Color.Green8};
`;
